import React from 'react';
import { Link } from 'react-router-dom';
import { FaChevronRight, FaHome } from 'react-icons/fa';
import './PageHeader.css';

/**
 * PageHeader — standardised page title bar with breadcrumbs and action slot.
 *
 * Usage:
 *   <PageHeader
 *     title="Anchor Points"
 *     breadcrumbs={[
 *       { label: 'Dashboard', to: '/dashboard' },
 *       { label: 'Property Name', to: `/propertydashboard/${id}` },
 *       { label: 'Roof Safety', to: `/propertydashboard/${id}/roof-safety` },
 *       { label: 'Anchor Points' },   // last item = no link (current page)
 *     ]}
 *     actions={<button className="btn-primary">Add New</button>}
 *   />
 */
const PageHeader = ({ title, subtitle, breadcrumbs = [], actions, icon: Icon, className = '' }) => {
  return (
    <div className={`page-header ${className}`}>
      {breadcrumbs.length > 0 && (
        <nav className="ph-breadcrumb" aria-label="Breadcrumb">
          <FaHome className="ph-bc-home" />
          {breadcrumbs.map((crumb, i) => (
            <React.Fragment key={i}>
              <FaChevronRight className="ph-bc-sep" />
              {crumb.to ? (
                <Link to={crumb.to} className="ph-bc-link">{crumb.label}</Link>
              ) : (
                <span className="ph-bc-current">{crumb.label}</span>
              )}
            </React.Fragment>
          ))}
        </nav>
      )}

      <div className="ph-row">
        <div className="ph-title-group">
          {Icon && (
            <div className="ph-icon">
              <Icon />
            </div>
          )}
          <div>
            <h1 className="ph-title">{title}</h1>
            {subtitle && <p className="ph-subtitle">{subtitle}</p>}
          </div>
        </div>

        {actions && (
          <div className="ph-actions">{actions}</div>
        )}
      </div>
    </div>
  );
};

export default PageHeader;
